import { render, staticRenderFns } from "./PaymentPeriodicityType.vue?vue&type=template&id=67a99bd0"
import script from "./PaymentPeriodicityType.vue?vue&type=script&lang=js"
export * from "./PaymentPeriodicityType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a99bd0')) {
      api.createRecord('67a99bd0', component.options)
    } else {
      api.reload('67a99bd0', component.options)
    }
    module.hot.accept("./PaymentPeriodicityType.vue?vue&type=template&id=67a99bd0", function () {
      api.rerender('67a99bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/PaymentPeriodicityType.vue"
export default component.exports